import { render, staticRenderFns } from "./StageSummaryLoader.vue?vue&type=template&id=904490f0&"
import script from "./StageSummaryLoader.vue?vue&type=script&lang=js&"
export * from "./StageSummaryLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports